const MicrosoftPpt = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_9661_42796)">
      <path
        d="M17.9988 8.5C17.9988 3.80552 14.0998 0 9.29001 0C4.48021 0 0.581055 3.80552 0.581055 8.5C0.581055 13.1945 4.48021 17 9.29001 17C14.0998 17 17.9988 13.1945 17.9988 8.5Z"
        fill="url(#paint0_linear_9661_42796)"
      />
      <path
        d="M17.9988 8.5C17.9988 3.80552 14.0998 0 9.29001 0C4.48021 0 0.581055 3.80552 0.581055 8.5C0.581055 13.1945 4.48021 17 9.29001 17C14.0998 17 17.9988 13.1945 17.9988 8.5Z"
        fill="url(#paint1_radial_9661_42796)"
      />
      <path
        d="M17.9988 8.5C17.9988 3.80552 14.0998 0 9.29001 0C4.48021 0 0.581055 3.80552 0.581055 8.5C0.581055 13.1945 4.48021 17 9.29001 17C14.0998 17 17.9988 13.1945 17.9988 8.5Z"
        fill="url(#paint2_radial_9661_42796)"
      />
      <path
        d="M9.29058 0C14.1003 0.000118048 17.9993 3.80564 17.9993 8.5C17.9993 10.0616 17.567 11.5243 16.8141 12.7819L16.9556 12.476C17.8175 10.6084 16.4166 8.49492 14.3176 8.49646L10.8514 8.49906C9.98978 8.49976 9.29058 7.81799 9.29058 6.97708V3.58818C9.29046 1.53897 7.12248 0.173306 5.20925 1.01728L4.93066 1.14042C6.21292 0.415319 7.70203 0 9.29058 0Z"
        fill="url(#paint3_linear_9661_42796)"
      />
      <path
        d="M9.29058 0C14.1003 0.000118048 17.9993 3.80564 17.9993 8.5C17.9993 10.0616 17.567 11.5243 16.8141 12.7819L16.9556 12.476C17.8175 10.6084 16.4166 8.49492 14.3176 8.49646L10.8514 8.49906C9.98978 8.49976 9.29058 7.81799 9.29058 6.97708V3.58818C9.29046 1.53897 7.12248 0.173306 5.20925 1.01728L4.93066 1.14042C6.21292 0.415319 7.70203 0 9.29058 0Z"
        fill="url(#paint4_radial_9661_42796)"
      />
      <path
        d="M9.29058 0C14.1003 0.000118048 17.9993 3.80564 17.9993 8.5C17.9993 10.0616 17.567 11.5243 16.8141 12.7819L16.9556 12.476C17.8175 10.6084 16.4166 8.49492 14.3176 8.49646L10.8514 8.49906C9.98978 8.49976 9.29058 7.81799 9.29058 6.97708V3.58818C9.29046 1.53897 7.12248 0.173306 5.20925 1.01728L4.93066 1.14042C6.21292 0.415319 7.70203 0 9.29058 0Z"
        fill="url(#paint5_radial_9661_42796)"
      />
      <path
        d="M9.29058 0C14.1003 0.000118048 17.9993 3.80564 17.9993 8.5C17.9993 10.0616 17.567 11.5243 16.8141 12.7819L16.9556 12.476C17.8175 10.6084 16.4166 8.49492 14.3176 8.49646L10.8514 8.49906C9.98978 8.49976 9.29058 7.81799 9.29058 6.97708V3.58818C9.29046 1.53897 7.12248 0.173306 5.20925 1.01728L4.93066 1.14042C6.21292 0.415319 7.70203 0 9.29058 0Z"
        fill="url(#paint6_radial_9661_42796)"
      />
      <path
        d="M9.29058 0C14.1003 0.000118048 17.9993 3.80564 17.9993 8.5C17.9993 10.0616 17.567 11.5243 16.8141 12.7819L16.9556 12.476C17.8175 10.6084 16.4166 8.49492 14.3176 8.49646L10.8514 8.49906C9.98978 8.49976 9.29058 7.81799 9.29058 6.97708V3.58818C9.29046 1.53897 7.12248 0.173306 5.20925 1.01728L4.93066 1.14042C6.21292 0.415319 7.70203 0 9.29058 0Z"
        fill="url(#paint7_radial_9661_42796)"
      />
      <path
        d="M1.82813 8.04688H7.17188C8.18159 8.04688 9 8.86528 9 9.875V15.2188C9 16.2285 8.18159 17.0469 7.17188 17.0469H1.82813C0.818408 17.0469 0 16.2285 0 15.2188V9.875C0 8.86528 0.818408 8.04688 1.82813 8.04688Z"
        fill="url(#paint8_radial_9661_42796)"
      />
      <path
        d="M1.82812 8.04688H7.17187C8.18159 8.04688 9 8.86528 9 9.875V15.2187C9 16.2285 8.18159 17.0469 7.17187 17.0469H1.82812C0.818408 17.0469 0 16.2285 0 15.2187V9.875C0 8.86528 0.818408 8.04688 1.82812 8.04688Z"
        fill="url(#paint9_radial_9661_42796)"
      />
      <path
        d="M3.54098 13.546V15.5H2V9.5H4.38068C5.23306 9.5 5.88189 9.66321 6.32719 9.98962C6.77579 10.3159 7 10.7998 7 11.4414C7 12.1026 6.74869 12.6185 6.24608 12.9895C5.74678 13.3605 5.07553 13.546 4.23271 13.546H3.54098ZM3.54098 10.5377V12.5083H4.18514C4.56668 12.5083 4.86107 12.4206 5.06773 12.2448C5.27439 12.0691 5.37791 11.8167 5.37791 11.4875C5.37791 11.1835 5.27595 10.9492 5.07241 10.7845C4.87199 10.6199 4.58422 10.5377 4.20892 10.5377H3.54098Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_9661_42796"
        x1="8.40629"
        y1="-0.541162"
        x2="-2.01601"
        y2="9.67533"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0582736" stopColor="#FF7F48" />
        <stop offset="1" stopColor="#E5495B" />
      </linearGradient>
      <radialGradient
        id="paint1_radial_9661_42796"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-12.3651 12.0674 -20.8121 -20.311 12.7325 4.93258)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.151523" stopColor="#AA1D2D" />
        <stop offset="0.380855" stopColor="#D12B18" stopOpacity="0.439216" />
        <stop offset="0.601996" stopColor="#FF3C00" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_9661_42796"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(14.9888 -6.90934 12.826 26.5006 -2.45876 15.4093)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.4067" stopColor="#FF66FB" stopOpacity="0.501961" />
        <stop offset="1" stopColor="#EA3D01" stopOpacity="0" />
      </radialGradient>
      <linearGradient
        id="paint3_linear_9661_42796"
        x1="10.9388"
        y1="10.3914"
        x2="20.1495"
        y2="3.39635"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.310768" stopColor="#FF6E30" />
        <stop offset="0.634576" stopColor="#FFA05C" />
      </linearGradient>
      <radialGradient
        id="paint4_radial_9661_42796"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(11.0201 2.25363 -2.20149 10.253 7.82706 9.51642)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.78593" stopColor="#FFA05C" stopOpacity="0" />
        <stop offset="0.904889" stopColor="#FFCE84" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_9661_42796"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(9.51364 -6.07515 5.95305 8.87898 9.59343 8.37248)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.295239" stopColor="#FF99E9" stopOpacity="0.8" />
        <stop offset="0.727968" stopColor="#FF99E9" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_9661_42796"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(7.96314 -8.89727 8.32613 7.09748 8.31671 9.67014)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FD6EF9" />
        <stop offset="0.637205" stopColor="#FF9944" />
        <stop offset="0.85186" stopColor="#FCC479" />
      </radialGradient>
      <radialGradient
        id="paint7_radial_9661_42796"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-0.899484 5.94832 -13.7749 -1.98391 7.52447 1.12336)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.144283" stopColor="#FF8D13" />
        <stop offset="0.537266" stopColor="#FF7F29" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint8_radial_9661_42796"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-0.00109649 8.04688) rotate(45) scale(12.7279)"
      >
        <stop stopColor="#F8193E" />
        <stop offset="0.939062" stopColor="#920616" />
      </radialGradient>
      <radialGradient
        id="paint9_radial_9661_42796"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(4.49888 13.4469) rotate(90) scale(6.3 7.17187)"
      >
        <stop offset="0.575893" stopColor="#FFB055" stopOpacity="0" />
        <stop offset="0.973806" stopColor="#FFF2BE" stopOpacity="0.301961" />
      </radialGradient>
      <clipPath id="clip0_9661_42796">
        <rect width="18" height="17" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default MicrosoftPpt;
